import type { TActions, TActionTrigger } from '../models';

interface ICreateActionData {
    /** Экшен */
    action: string | string[];
    /** Список экшенов */
    actions: TActions<string>;
}

type TCreateAction = (props: ICreateActionData) => TActionTrigger;

/** Создать экшен на основе одного или массива экшенов */
export const createAction: TCreateAction = ({ action, actions }) =>
    Array.isArray(action) ? props => action.map(func => actions[func](props)) : actions[action];
